module.exports = __webpack_public_path__ + "static/media/threestepicon1.1487c696.png";